import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { H2, LabelBold } from '@comeon/ui';

import Icon, { ICON_CIRCLE_CHECKMARK } from '~/components/icon';
import useTranslations from '~/components/translation/use-translations';
import Loading from '~/components/misc/loading';
import { selectCurrency, selectLocale } from '~/components/account/ducks';
import { WE_SPIN_BUY_IN_TEXT_KEYS } from '../constants/we-spin-text-keys';

import currencyFormatter from '~/libs/currency-formatter';

const BuyInAmountWrapper = styled.div`
	border-radius: 12px;
	background-color: var(--link-list, rgba(var(--base-10), 1));
`;

const IconWrapper = styled.div`
	background-color: var(--sidebar-bg, rgba(var(--base-11), 1));
	height: 40px;
	width: 40px;
	padding: 6px;
	border-radius: 10px;
	svg {
		color: rgba(var(--primary-accent-green-light), 1);
	}
`;

const BuyInAmount = props => {
	const locale = useSelector(selectLocale);
	const playerCurrency = useSelector(selectCurrency);

	const { translations: tr, isLoadingTranslations } = useTranslations(WE_SPIN_BUY_IN_TEXT_KEYS);

	if (isLoadingTranslations) return <Loading />;

	return (
		<BuyInAmountWrapper className="u-p1 u-flex">
			<IconWrapper className="u-mr1 u-flex u-fxb-center-v-h we-spin-buy-in-ammout">
				<Icon type={ICON_CIRCLE_CHECKMARK} />
			</IconWrapper>
			<div>
				<LabelBold>{tr.WE_SPIN_BUY_IN_YOUR_BOUGHT}</LabelBold>
				<H2>{currencyFormatter.format(props.amount, playerCurrency, locale)}</H2>
				<small>{tr.WE_SPIN_BUY_IN_YOUR_BOUGHT_HINT}</small>
			</div>
		</BuyInAmountWrapper>
	);
};

export default BuyInAmount;
